// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import NewsRow from 'components/fragments/NewsRow';
import { formatFullDate, getDateFromString } from 'utils/dateUtils';
import type { ArticleType } from 'types/Article';

type Props = {
  articles: Array<ArticleType>,
  slug: string,
  label: string
};

class FooterTeamArticle extends PureComponent<Props> {
  props: Props;

  renderArticles = (): any => {
    const { articles } = this.props;
    return articles.map((article, index) => {
      if (index < 4) {
        return(
          <NewsRow
            key={`${article.title}_${index}`}
            slug={article.slug}
            categorySlug={article.label.slug}
            categoryName={article.label.name}
            img={article.illustration}
            title={article.title}
            date={formatFullDate(getDateFromString(article.date))}
          />
        );
      }
      return null;
    });
  };

  render() {
    return (
      <section className="section section-white">
        <div className="container">
          <div className="row">
            <div className="col">
              <Link
                to={`/actualites/${this.props.slug}`}
                title={`Voir plus`}
                className="link-chevron link-chevron--right section__link mt-1"
                data-label=""
              >
                <span>{`Voir toute l'actualité de l'équipe`}</span>
                <i className="icon icon-chevron-right" />
              </Link>
              <h3 className="ft-h2 mb-3 mb-lg-4">{`Actualités de l'équipe`}</h3>
              <div className="billboard__news billboard__news--fullWidth">
                {this.renderArticles()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FooterTeamArticle;
